import { Renderable } from "../../../types/react";
import { Loader } from "./Loader";
import { PropsWithChildren } from "react";
export const BUTTON_TYPE = {
  xs: " rounded-xl p-2 ",
  small: " rounded-xl p-2 px-4 ",
  large: " rounded-xl p-4 max-w-full w-[500px] ",
  nav: " py-2 px-5 rounded-[10px] ",
  text: " ",
  none: "",
} as const;

export const BUTTON_COLORS = {
  success:
    " inline-block my-1 text-textSuccess bg-success duration-150 border-2 border-solid border-transparent hover:bg-white hover:text-textBlack disabled:bg-disabled disabled:text-textDisabled shadow-lg hover:shadow-xl disabled:hover:shadow-none disabled:shadow-none ",
  primary:
    " inline-block my-1 text-textPrimary bg-primary duration-150 border-2 border-solid border-transparent hover:bg-white hover:text-textBlack hover:border-primary disabled:bg-disabled disabled:text-textDisabled  shadow-lg hover:shadow-xl disabled:hover:shadow-none disabled:shadow-none ",
  secondary:
    " inline-block my-1 text-textSecondary bg-secondary duration-150 border-2 border-solid border-transparent hover:bg-white hover:text-textBlack hover:border-secondary disabled:bg-disabled disabled:text-textDisabled shadow-lg hover:shadow-xl disabled:hover:shadow-none disabled:shadow-none ",
  accent:
    " inline-block my-1 text-textAccent bg-accent duration-150 border-2 border-solid border-transparent hover:bg-white hover:text-textBlack disabled:bg-disabled disabled:text-textDisabled shadow-lg hover:shadow-xl disabled:hover:shadow-none disabled:shadow-none ",
  text: " inline-block my-1 text-textMain duration-150 border-b-2 border-solid border-textMain md:hover:border-textMain md:border-transparent disabled:text-textDisabled ",

  warning:
    " inline-block my-1 text-textWarning bg-warning duration-150 border-2 border-solid border-textWarning md:border-transparent md:hover:border-textWarning disabled:bg-disabled disabled:text-textDisabled shadow-lg hover:shadow-xl disabled:hover:shadow-none disabled:shadow-none ",
  nav: " backdrop-blur-lg inline-block my-1 text-textMain border-2 border-solid border-textMain md:hover:border-textMain md:border-transparent duration-150 shadow-lg hover:shadow-xl disabled:hover:shadow-none disabled:shadow-none ",
  none: " inline-block my-1  duration-150 ",
} as const;

export const Button = ({
  children,
  btnType,
  btnColor,
  loading,
  disabled,
  loaderSpinner,
  loaderText,
  ...props
}: JSX.IntrinsicElements["button"] & {
  btnType: keyof typeof BUTTON_TYPE;
  btnColor: keyof typeof BUTTON_COLORS;
  loading?: boolean;
  children: Renderable;
  loaderText?: string;
  loaderSpinner?: boolean;
}) => {
  let className = props.className || "";
  className += BUTTON_TYPE[btnType] ?? "";
  className += BUTTON_COLORS[btnColor] ?? "";

  return (
    <button {...props} disabled={disabled || loading} className={className}>
      {loading ? (
        <Loader
          borderColor={
            btnColor === "nav" || btnColor === "text" || btnColor === "none"
              ? undefined
              : btnColor
          }
          type={loaderSpinner || !loaderText ? "spinner" : "text"}
        >
          {loaderText}
        </Loader>
      ) : (
        children
      )}
    </button>
  );
};

export const ButtonLink = ({
  children,
  btnType,
  btnColor,
  loading,
  disabled,
  loaderSpinner,
  loaderText,
  ...props
}: (JSX.IntrinsicElements["a"] & JSX.IntrinsicElements["button"]) & {
  btnType: keyof typeof BUTTON_TYPE;
  btnColor: keyof typeof BUTTON_COLORS;
  loading?: boolean;
  children: Renderable;
  loaderText?: string;
  loaderSpinner?: boolean;
}) => {
  let className = props.className || "";
  className += BUTTON_TYPE[btnType] ?? "";
  className += BUTTON_COLORS[btnColor] ?? "";
  const Element = (eprops: PropsWithChildren) =>
    disabled || loading || !props.href ? (
      <button
        {...props}
        disabled={disabled || loading || !props.href}
        className={className}
      >
        {eprops.children}
      </button>
    ) : (
      <a {...props} className={className}>
        {" "}
        {eprops.children}
      </a>
    );

  return (
    <Element>
      {loading ? (
        <Loader
          borderColor={
            btnColor === "nav" || btnColor === "text" || btnColor === "none"
              ? undefined
              : btnColor
          }
          type={loaderSpinner || !loaderText ? "spinner" : "text"}
        >
          {loaderText}
        </Loader>
      ) : (
        children
      )}
    </Element>
  );
};
